export default __webpack_public_path__ + "static/6619-b25f5e7d05ad2bda304e00607a0a10da.jpg";